'use strict';

import { SHIPMENT_RANK } from '@clickorico/shared-domain/expeditionDisplayState';

/**
 * UI Admin — « Colis remis au transporteur » (handoff LABEL_CREATED → SHIPPED).
 */

export function canShowExpeditionMerchantHandoffButton(commande) {
  if (!commande || commande.modeRetrait !== 'expedition') return false;
  const shipment = commande.shipment;
  if (!shipment?.id) return false;
  const providerShipmentId =
    shipment.providerShipmentId != null ? String(shipment.providerShipmentId).trim() : '';
  if (!providerShipmentId) return false;
  return String(shipment.status || '').toUpperCase() === 'LABEL_CREATED';
}

export function expeditionMerchantHandoffConfirmCopy() {
  return {
    title: 'Colis remis au transporteur',
    description: 'Confirmer que le colis a été remis au transporteur ?',
    confirmLabel: 'Confirmer',
  };
}

/** Affichage statut colis après handoff (merchant labels). */
export function expeditionHandoffResultStatusLabel(shipmentStatus) {
  const key = String(shipmentStatus || '').trim().toUpperCase();
  if (key === 'SHIPPED') return 'Expédiée';
  if (Object.prototype.hasOwnProperty.call(SHIPMENT_RANK, key) && SHIPMENT_RANK[key] >= SHIPMENT_RANK.SHIPPED) {
    return 'Expédiée';
  }
  return null;
}
